import axios from 'axios';

import { CalendarProvider } from '@tallo/user';

import { CreateCalendarIntegrationDto } from '../model/create-calendar-integration.dto';

class GoogleCalendarService {
  async connect(): Promise<string> {
    try {
      const { data } = await axios.get<{ url: string; message: string }>('/calendar/auth-url');
      return data.url;
    } catch (error) {
      console.error('Failed to get Google Calendar auth URL:', error);
      throw new Error('Failed to initiate Google Calendar connection');
    }
  }

  async disconnect(provider: CalendarProvider): Promise<void> {
    try {
      await axios.delete(`/calendar/unlink/${provider}`);
    } catch (error) {
      console.error('Failed to disconnect Google Calendar:', error);
      throw new Error('Failed to disconnect Google Calendar');
    }
  }

  async handleAuthCallback(code: string, isPrimary: boolean = true): Promise<void> {
    try {
      const calendarIntegration: CreateCalendarIntegrationDto = {
        code,
        provider: CalendarProvider.GOOGLE,
        isPrimary,
      };

      await axios.post('/calendar/link', calendarIntegration);
    } catch (error) {
      console.error('Failed to complete Google Calendar authorization:', error);
      throw new Error('Failed to connect Google Calendar');
    }
  }
}

export default new GoogleCalendarService();
